export default __webpack_public_path__ + "static/media/Totem of the Faceless Sphinx.4a6b39a8.jpg";